import { Routes, Route } from 'react-router-dom';
import {
  ROOT,
  LOGIN,
  RESETPASS,
  SIGNUP,
  AUTHROOT,
  LTVLIBHOME,
  LTVLIBCATEGORY,
  LTVLIBNEWANDFEATURED,
  LTVLIBLINKTIVITY,
  PROFILE,
  SUBSCRIPTION,
  BILLING,
  REFER,
} from './CONSTANTS';
import Login from '../features/login';
import PasswordReset from '../features/passwordReset';
import SignUp from '../features/signUp';
import AuthHome from '../features/authHome';
import LtvLibHome from '../features/linktivityLibrary/libraryHome';
import LtvLibCategory from '../features/linktivityLibrary/category';
import LtvLibNewAndFeatured from '../features/linktivityLibrary/newAndFeaturedLTVs';
import LtvLibLinktivty from '../features/linktivityLibrary/singleLinktivity';
import Profile from '../features/profile';
import Subscription from '../features/subscription';
import Billing from '../features/billing';
import Refer from '../features/refer';
import { NotFound } from './NotFound';
import RequireAuth from '../common/auth/RequireAuth';
import UsesSubscriptionInfo from '../common/auth/UsesSubscriptionInfo';

export const RouterConfig = () => {
  return (
    <Routes>
      {/* PUBLIC ROUTES */}
      <Route path={ROOT} element={<Login />} />
      <Route path={RESETPASS} element={<PasswordReset />} />
      <Route path={LOGIN} element={<Login />} />
      <Route
        path={SIGNUP + '/:referrer?'}
        element={
          <UsesSubscriptionInfo>
            <SignUp />
          </UsesSubscriptionInfo>
        }
      />
      <Route
        path={LTVLIBHOME}
        element={
          <UsesSubscriptionInfo>
            <LtvLibHome />
          </UsesSubscriptionInfo>
        }
      />
      <Route
        path={LTVLIBCATEGORY}
        element={
          <UsesSubscriptionInfo>
            <LtvLibCategory />
          </UsesSubscriptionInfo>
        }
      />
      <Route
        path={LTVLIBNEWANDFEATURED}
        element={
          <UsesSubscriptionInfo>
            <LtvLibNewAndFeatured />
          </UsesSubscriptionInfo>
        }
      />
      <Route
        path={LTVLIBLINKTIVITY}
        element={
          <UsesSubscriptionInfo>
            <LtvLibLinktivty />
          </UsesSubscriptionInfo>
        }
      />

      {/* AUTHENTICATED ROUTES */}
      <Route
        path={AUTHROOT}
        element={
          <RequireAuth>
            <AuthHome />
          </RequireAuth>
        }
      />
      <Route
        path={PROFILE}
        element={
          <RequireAuth>
            <Profile />
          </RequireAuth>
        }
      />
      <Route
        path={SUBSCRIPTION}
        element={
          <RequireAuth>
            <Subscription />
          </RequireAuth>
        }
      />
      <Route
        path={BILLING}
        element={
          <RequireAuth>
            <Billing />
          </RequireAuth>
        }
      />
      <Route
        path={REFER}
        element={
          <RequireAuth>
            <Refer />
          </RequireAuth>
        }
      />

      <Route path='*' element={<NotFound />} />
    </Routes>
  );
};

export default RouterConfig;
